<template>
  <CRow>
    <CCol>
      <CForm>
        <CCard>
          <CCardHeader>
            <CIcon name="cil-pencil" class="mr-2"/>
            <strong class="m-2">Linh kiện loại:</strong>
            <span style="text-decoration: underline;">{{params.component}}</span>
            <strong class="m-2">Mã:</strong>
            <span style="text-decoration: underline;">{{params.part}}</span>

            <div class="card-header-actions">
              <CButton type="button" shape="pill" color="info" class="mr-2" @click="save">
                <CIcon name="cil-save"/>
                Lưu lại</CButton>
              <CButton type="button" shape="pill" color="secondary" class="mr-2"
                       @click="refresh">
                <CIcon name="cil-sync"/>
                Tải lại</CButton>
              <CButton type="button" shape="pill" color="secondary" @click="goBack">
                <CIcon name="cil-chevron-left"/>
                Quay lại</CButton>
            </div>
          </CCardHeader>
          <CCardBody class="pt-2">
            <CRow>
              <CCol>
                <table style="width: 100%;">
                  <tbody>
                  <tr class="gradeX" v-for="(value, index) in values"
                      :key="index"
                      v-if="!shouldHide(headers[index].label)">
                    <td class="col-lg-5 text-right" style="font-weight: bold;">
                      {{ headers[index].label }}
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        :readonly="isReadonly(headers[index].label)"
                        v-model="values[index]"
                        :placeholder="!isReadonly(headers[index].label) ?
                        'Nhập ' + headers[index].label : 'Tự động'"
                      />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </CCol>
              <CCol class="d-flex justify-content-center align-items-center">
                <table style="width: 100%;">
                  <tr>
                    <td colspan="5" class="text-center">
                      <img
                        v-if="imageSource!==''"
                        alt="hình ảnh"
                        :src="imageSource" style="width: 300px;">
                      <span class="text-center" v-else>Chưa có ảnh</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-right">
                      <span>
                        Tải ảnh lên
                      </span>
                    </td>
                    <td colspan="2">
                    <label
                      style="border: 1px solid #ced4da;border-radius: 0.375rem; padding: 0.375rem 0.75rem;"
                      class="m-1"
                      for="fileInputImage"
                    >{{ fileNameImage }}
                    </label>
                    <input type="file"
                           id="fileInputImage"
                           accept=".jpg,.jpeg,.png,.gif,.svg"
                           style="display: none;"
                           @change="onFileImageChange">
                    </td>
                    <td>
                      <CButton v-if="selectedFileImage" shape="pill" color="info"
                               class="mr-2"
                               @click="handleUploadImage"
                               :disabled="isUploadingImage"
                      >
                        <CIcon name="cil-cloud-upload"/>
                        {{ isUploadingImage ? "Đang tải..." : "Tải lên" }}
                      </CButton>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-right">
                      <span>
                        Tải tài liệu lên
                      </span>
                    </td>
                    <td colspan="2">
                      <label
                        style="border: 1px solid #ced4da;border-radius: 0.375rem; padding: 0.375rem 0.75rem;"
                        class="m-1"
                        for="fileInputDocument"
                      >{{ fileNameDocument }}
                      </label>
                      <input type="file"
                             id="fileInputDocument"
                             style="display: none;"
                             @change="onFileDocumentChange">
                    </td>
                    <td>
                      <CButton v-if="selectedFileDocument" shape="pill" color="info"
                               class="mr-2"
                               @click="handleUploadDocument"
                               :disabled="isUploadingDocument"
                      >
                        <CIcon name="cil-cloud-upload"/>
                        {{ isUploadingDocument ? "Đang tải..." : "Tải lên" }}
                      </CButton>
                    </td>
                    <td>
                      <CButton v-if="gotInfo && documentSource" shape="pill" color="info"
                               class="mr-2"
                               @click="viewFile(documentSource)"
                      ><CIcon name="cil-screen-desktop" class="mr-2"/>Xem tài liệu</CButton>
                    </td>
                  </tr>
                </table>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      headers: [],
      values: [],
      params: {
        component: '',
        part: '',
        criteria: '',
        searched: false,
      },
      hideSubstrings: ["id",
        "Nhóm linh kiện",
        "Số lượng đặt trước",
        "Số lượng khả dụng"],
      fileNameImage: 'Chọn ảnh',
      selectedFileImage: null,
      isUploadingImage: false,
      isUploadingDocument: false,
      fileNameDocument: 'Chọn tài liệu',
      selectedFileDocument: null,
      gotInfo: false,
    };
  },
  created() {
    this.params.component = this.$route.query.component
    this.params.part = this.$route.query.part
    this.params.criteria = this.$route.query.criteria
    this.params.searched = this.$route.query.searched
    // console.log('request: ', this.params)
    if(this.params.component) {
      if(this.params.part) {
        // console.log('edit component: ', this.params.component)
      } else {
        // console.log('create component: ', this.params.component)
      }
    } else {
      // console.log('invalid request params: ', this.params)
    }
    this.getComponent(this.params)
  },
  computed:{
    imageSource() {
      let imgSrc = ''
      if (this.headers.length > 0) {
        let index = this.headers.findIndex(item => item.label.includes("hình ảnh"));
        if (index > -1 && this.values.length > index) {
          imgSrc = this.values[index];
        }
      }
      // console.log('image source:', imgSrc)
      return imgSrc;
    },
    documentSource() {
      let docSrc = ''
      if (this.headers.length > 0) {
        let index = this.headers.findIndex(item => item.label.includes("tài liệu"));
        if (index > -1 && this.values.length > index) {
          docSrc = this.values[index];
        }
      }
      // console.log('doc source:', docSrc)
      return docSrc;
    }
  },
  methods: {
    getComponent(params) {
      // console.log('do request with params: ', params)
      this.$request.get(`/api/repo/mod`, {params}).
        then(res => {
          if(res.data.headers) {
            this.headers = res.data.headers
            this.values = res.data.values
            this.updateDependValue()
          } else {
            // console.log('response invalid: ', res.data)
          }
      })
    },
    updateDependValue() {
      let index = this.headers.findIndex(item => item.label.includes("Nhóm linh kiện"));
      if (index > -1) {
        this.values[index] = this.params.component
      }
      this.gotInfo=true
    },
    refresh() {
      this.getComponent(this.params)
    },
    save() {
      // console.log('save item: ', this.params)
      this.$swal.fire({
        title: "Do you want to save component?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(
            '/api/repo/mod',
            {
              component: this.params.component,
              values: this.values,
            }
          ).then(res => {
            if(res.data.status === 'success') {
              this.headers = res.data.headers
              this.values = res.data.values
              this.updateDependValue()
              this.$swal.fire({
                icon: "success",
                title: "Save component",
                text: "Save component: " + this.params.component + " success" ,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Save component",
                text: "Save component: " + this.params.component +
                  " error: " + res.data.status,
              });
            }
          })
        }
      });
    },
    goBack() {
      // console.log('back with param:', this.params)
      if(this.params.searched) {
        this.$router.push({
          path: `/component/search`,
          query: this.params,
        })
      } else {
        this.$router.go(-1)
      }
    },
    isReadonly(str){
      const substrArray = ["id", "Mô tả", "EES CODE"];
      const lowerStr = str.toLowerCase();
      return substrArray.some(sub => lowerStr === sub.toLowerCase());
    },
    shouldHide(label) {
      // Check if the label contains any of the substrings
      return this.hideSubstrings.some(sub =>
        label.toLowerCase().includes(sub.toLowerCase())
      );
    },
    onFileImageChange(event) {
      this.selectedFileImage = event.target.files[0];
      if (this.selectedFileImage) {
        this.fileNameImage = this.selectedFileImage.name;
        // console.log('selected file name:', this.fileNameImage)
      } else {
        // console.log('no file selected');
        this.fileNameImage = 'Chọn ảnh'
      }
    },
    onFileDocumentChange(event) {
      this.selectedFileDocument = event.target.files[0];
      if (this.selectedFileDocument) {
        this.fileNameDocument = this.selectedFileDocument.name;
        // console.log('selected file name:', this.fileNameDocument)
      } else {
        // console.log('no file selected');
        this.fileNameDocument = 'Chọn tài liệu'
      }
    },
    handleUploadData(fileName, fileData, dataType) {
      // console.log("upload: ", fileName, dataType);
      let index = this.headers.findIndex(item => item.label.includes("Mã"));
      let partNumber = ''
      if (index > -1) {
        partNumber = this.values[index]
      }

      const formData = new FormData();
      formData.append("file", fileData);
      formData.append("component", this.params.component);
      formData.append("part", partNumber);
      formData.append("data-type", dataType);

      // Send file using Axios
      this.$request.post("/api/repo/static/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        if (res.data.status === 'success') {
          // console.log(res.data)
          if (res.data.headers.length > 0) {
            this.headers = res.data.headers
            this.values = res.data.values
            this.updateDependValue()
          }
          this.$swal.fire({
            icon: "success",
            title: "Tải lên tệp",
            text: "Tệp: " + fileName + " đã tải lên thành công!",
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Tải lên tệp",
            html: "Tệp: " + fileName + " tải lên lỗi: " + res.data.status,
          });
        }
      }).catch((error) => {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên tệp",
          html: "Tệp: " + fileName + " tải lên lỗi: " + error,
        });
      })
    },
    handleUploadImage() {
      if (!this.selectedFileImage) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }
      // console.log('upload image: ', this.fileNameImage);
      this.isUploadingImage = true;
      this.handleUploadData(this.fileNameImage, this.selectedFileImage, 'image');
      this.isUploadingImage = false;
    },
    handleUploadDocument(){
      if (!this.selectedFileDocument) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }
      this.isUploadingDocument = true;
      this.handleUploadData(this.fileNameDocument, this.selectedFileDocument, 'document');
      this.isUploadingDocument = false;
    },
    viewFile(url) {
      // Example: Construct a URL where the file is hosted
      // const fileUrl = encodeURIComponent(url);

      // Option 1: Open file in a new tab/window
      window.open(url, '_blank');

      // Option 2: If you want to download the file, you can set window.location.href
      // window.location.href = fileUrl;

      // Option 3: If you want to fetch the file content and process it, you could use axios/fetch.
      // axios.get(fileUrl, { responseType: 'blob' }).then(response => {
      //   // process the blob response
      // });
    }

  },
};
</script>

